import { FinalizePermissions } from "types/graphql-schema";

import { getLabel } from "@apps/use-label/use-label";

export const getFinalizePermissionLabel = (
  finalizePermission: FinalizePermissions,
) => {
  const label = getLabel();
  const finalizePermissionLabel =
    finalizePermission === FinalizePermissions.ManagersAndAdmins
      ? "managers and admins"
      : finalizePermission === FinalizePermissions.AdminsOnly
        ? "admins only"
        : finalizePermission === FinalizePermissions.FacilitatorsAndAdmins
          ? "facilitator and admins"
          : finalizePermission === FinalizePermissions.AllParticipants
            ? "all participants"
            : "";
  return `${
    finalizePermissionLabel
      ? `This ${label(
          "oneonone",
        )} can be finalized by ${finalizePermissionLabel}.`
      : ""
  }`;
};
